import Joi from 'joi';

import { PricingItemTypeEnum } from '../../enums/pricing-item-type.enum';

/**
 * Schema for record validation.
 * @description This schema is used to validate the record properties when creating or updating the record.
 */
export const pricingItemSchema = () =>
  Joi.object({
    // Description
    description: Joi.string().allow(null, '').max(256).messages({
      'string.max': 'validations|pricing-item-description|max-length',
    }),

    // Type
    type: Joi.string()
      .valid(...Object.values(PricingItemTypeEnum))
      .required()
      .messages({
        'any.required': 'validations|pricing-item-type|required',
        'any.only': 'validations|pricing-item-type|invalid-value',
      }),

    // Units
    units: Joi.any().required().messages({
      'any.required': 'validations|pricing-item-units|required',
    }),

    pricingItemPresetId: Joi.number().allow(null),

    // NOT NULL boolean: omit = leave untouched on update; null treated as unset.
    // Do not .default(false) here — shared create/update schema must preserve omit.
    isStandardDiscountApplied: Joi.boolean().empty(null),
  })
    // Ignore extra fields
    .unknown();
